"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.internalRox = exports.isBrowser = void 0;
let Rox;
if (1 === 1) {
    Rox = require('rox-browser');
}
else {
    Rox = require('rox-node');
    Rox.setContext({ server: true });
}
function isBrowser() {
    return typeof window !== 'undefined';
}
exports.isBrowser = isBrowser;
exports.internalRox = Rox;
//# sourceMappingURL=utils.js.map